// components/features/faq/FaqRow.tsx
import { Faq } from "../../../types/features/Faq";
import TableRow from "../../ui/TableRow";
import { GripVertical } from "lucide-react";

interface FaqRowProps {
  faq: Faq;
  onAction: (faq: Faq) => void;
  onSelect?: (faq: Faq, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
  dragHandleProps?: any;
}

export default function FaqRow({
  faq,
  onAction,
  onSelect,
  isSelected = false,
  selectable = false,
  dragHandleProps,
}: FaqRowProps) {
  return (
    <TableRow
      item={faq}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      {dragHandleProps && (
        <td className="py-3 px-2 cursor-move" {...dragHandleProps}>
          <GripVertical size={18} className="text-gray-400" />
        </td>
      )}
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">{faq.question}</span>
          <span className="text-xs text-gray-500">Ordre: {faq.order}</span>
        </div>
      </td>

      <td className="py-3 px-4">
        <p className="text-gray-600 text-sm line-clamp-2 max-w-md">{faq.answer}</p>
      </td>

      <td className="hidden lg:table-cell py-3 px-4">
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            faq.is_visible ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
          }`}
        >
          {faq.is_visible ? "Visible" : "Masqué"}
        </span>
      </td>
    </TableRow>
  );
}
